export enum CompanyType {
  AkrochemWarehouse = "AKROCHEM_WAREHOUSE",
  Akrochem = "AKROCHEM",

  //Customer
  Customer = "CUSTOMER",
  Purchaser = "PURCHASER",
  ConsignmentWarehouse = "CONSIGNMENT_WAREHOUSE",
  // Vendor
  Vendor = "VENDOR",
  Transportation = "TRANSPORTATION",
  Marketing = "MARKETING",
  Advertizing = "ADVERTIZING",
  FinancialService = "FINANCIAL_SERVICE",
  Bank = "BANK",
  Insurance = "INSURANCE",
  CapitalInsurance = "CAPITAL_INSURANCE",
  MedicalInsurance = "MEDICAL_INSURANCE",
  TravelHospitality = "TRAVEL_HOSPITALITY",
  Lessor = "LESSOR",
  Vehicles = "LEASE_VEHICLES",
  Warehouse = "LEASE_WAREHOUSE",
  Workforce = "WORKFORCE",
  ContractedLabor = "LABOR_CONTRACT",
  SalariedLabor = "LABOR_SALARIED",
  IT = "IT",
  Hardware = "IT_HARDWARE",
  Software = "IT_SOFTWARE",
  Miscellaneous = "MISC",
  Supplier = "COMMODITY_VENDOR",
  AkrochemSupplier = "AKROCHEM_SUPPLIER",
  RevlisSupplier = "REVLIS_SUPPLIER",
  IntermediaryDestination = "INTERMEDIARY_DESTINATION",
}

export const CUSTOMER_COMPANY_TYPES: readonly CompanyType[] = [
  CompanyType.Customer,
  CompanyType.ConsignmentWarehouse,
  CompanyType.Purchaser,
]

export const CUSTOMER_ACCOUNT_STATUS_COMPANY_TYPES: readonly CompanyType[] = [
  CompanyType.Customer,
  CompanyType.Purchaser,
]

export const VENDOR_COMPANY_TYPES: readonly CompanyType[] = [
  CompanyType.Vendor,
  CompanyType.Transportation,
  CompanyType.Marketing,
  CompanyType.Advertizing,
  CompanyType.FinancialService,
  CompanyType.Bank,
  CompanyType.Insurance,
  CompanyType.CapitalInsurance,
  CompanyType.MedicalInsurance,
  CompanyType.TravelHospitality,
  CompanyType.Lessor,
  CompanyType.Vehicles,
  CompanyType.Warehouse,

  CompanyType.Workforce,
  CompanyType.ContractedLabor,
  CompanyType.SalariedLabor,
  CompanyType.IT,
  CompanyType.Hardware,
  CompanyType.Software,

  CompanyType.Miscellaneous,
  CompanyType.Supplier,
  CompanyType.AkrochemSupplier,
  CompanyType.RevlisSupplier,
  CompanyType.IntermediaryDestination,
]
